import { Component, Input } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import {
  QaiComparisonBlockComponent,
  QaiLoadingComponent,
  QaiResultsTabComponent,
} from '@qai/ui';
import {
  AccuracyFeedbackState,
  IAccuracyClaim,
} from 'src/app/interfaces/iaccuracy-feedback';
import { MessageBlockComponent } from 'src/app/components/shared/message-block/message-block.component';

/**
 * Renders one of four accuracy states as a roleplay results card.
 * Presentational only — the results service owns the fetch and the gate.
 */
@Component({
  selector: 'app-result-accuracy',
  standalone: true,
  imports: [
    TranslocoModule,
    QaiComparisonBlockComponent,
    QaiLoadingComponent,
    QaiResultsTabComponent,
    MessageBlockComponent,
  ],
  templateUrl: './result-accuracy.component.html',
  styleUrls: ['./result-accuracy.component.scss'],
})
export class ResultAccuracyComponent {
  @Input() state: AccuracyFeedbackState = AccuracyFeedbackState.Loading;
  @Input() claims: IAccuracyClaim[] = [];

  /** Exposed for the template's state comparisons. */
  readonly AccuracyFeedbackState = AccuracyFeedbackState;

  readonly flaggedIcon = 'message-question-square' as const;
  readonly clearIcon = 'message-check-square' as const;
  readonly errorIcon = 'message-question-square' as const;
}
